<template>
  <div class="text-page">
    <vue-headful :title="doctitle" />
    <div
      class="position-relative"
      style="max-width: 1900px; margin-left: auto; margin-right: auto"
    >
      <b-container>
        <b-row>
          <b-col>
            <h1>Welcome to Øredev</h1>
            <p>We couldn't be more thrilled to have you at Øredev! 🎉</p>
            <p class="mb-0">Read more about:</p>
            <ol class="link-list mb-0">
              <li><a href="#times-and-dates">Times and dates</a></li>
              <li><a href="#venue">Venue</a></li>
              <li><a href="#shipping-details">Shipping details</a></li>
              <li><a href="#where-to-stay">Where to stay</a></li>
              <li><a href="#registering-tickets">Registering tickets</a></li>
              <li><a href="#preparing">Preparing for Øredev</a></li>
              <li><a href="#mass-service">Malmö Mäss-Service</a></li>
              <li><a href="#during">During Øredev</a></li>
              <li><a href="#after">After Øredev</a></li>
              <li><a href="#reserve">Reserve a place for next year</a></li>
              <li><a href="#contacts">Contacts</a></li>
            </ol>

            <DividerPink />

            <h2 id="times-and-dates">Times And Dates</h2>
            <h3>Set-up</h3>
            <p>
              You have access to the venue to build your booth on Tuesday,
              November 4th, 12.00-17.00.
            </p>
            <p>
              If you are bringing materials by car, please go around the
              building to Mässgatan 6, where you'll find the loading bay. To
              gain access please call the number on the sign outside.
            </p>
            <h3>Opening hours during the conference</h3>
            <p>
              Wednesday 5th: 08.00 - 18.00<br aria-hidden="true" />
              Thursday 6th: 08.00 - 18.00 (18.00 - 21.30 Official afterparty)<br
                aria-hidden="true"
              />
              Friday 7th: 08.00 - 16.00
            </p>
            <p class="mb-0">
              You will have access to the venue at 8am in the morning, the same
              time as the delegates. Please ensure that you have set everything
              up the day before, as you will not have early access to your booth
              on the days of the conference.
            </p>

            <DividerBlue />

            <h2 id="venue">Venue</h2>
            <div style="overflow: hidden">
              <iframe
                src="https://www.google.com/maps/d/embed?mid=1w1hteu4iUbl-irqBXU_fIfoqJ4rG-jE&ehbc=2E312F"
                width="100%"
                height="480px"
                frameborder="0"
                style="margin-top: -120px; margin-bottom: -20px"
              ></iframe>
            </div>
            <p class="mt-1 mb-0">
              Malmömässan<br />
              Mässgatan 6, 215 32 Malmö<br />
              Phone number: +46 40 631 11 10
            </p>

            <DividerGreen />

            <h2 id="shipping-details">Shipping Details</h2>
            <p>
              Your goods should arrive in Malmö on the 3rd or 4th of
              November.<br aria-hidden="true" />
              The venue can receive your delivery the earliest on 3rd of
              November, and latest by the 4th.<br aria-hidden="true" />
              Your goods must be picked up from Malmö mässan no later than
              November 12.
            </p>
            <p class="mb-0">Please mark all goods with the following:</p>
            <ul>
              <li>
                Your company / Stand number / Name & mobile number of the
                contact person at your company
              </li>
            </ul>
            <p class="mb-0">Please send to the following address:</p>
            <ul class="mb-0">
              <li>Nya Malmö Mäss-Service AB</li>
              <li>Att: Øredev 2025</li>
              <li>Your company name / Stand number / Name & mobile number of the
              contact person at your company </li>
              <li>Mässgatan 6, 215 32 Malmö, SWEDEN</li>
            </ul>

            <DividerOrange />

            <h2 id="where-to-stay">Where to stay</h2>
            <p>
              Book your hotel as soon as possible. If you would like to stay
              close to the venue in Hyllie, we recommend either
              <a
                href="https://www.strawberry.se/hotell/sverige/malmo/quality-hotel-view/"
                target="_blank"
                rel="noopener noreferrer"
                >Quality Hotel View</a
              >
              or
              <a
                href="https://malmoarenahotel.com/"
                target="_blank"
                rel="noopener noreferrer"
                >Best Western Malmö Arena Hotel</a
              >. If you would rather stay in Malmö city there are plenty of
              options 10min away by train.
            </p>
            <p class="mb-0">
              If you would like help with booking, please contact
              <a href="mailto:info@oredev.org">info@oredev.org</a>
            </p>

            <DividerPink />

            <h2 id="registering-tickets">Registering Tickets</h2>
            <p>
              You need to register for the tickets included in your Partnership
              via our
              <a
                href="https://www.trippus.net/oredev2025/Partners"
                target="_blank"
                rel="noopener noreferrer"
                >ticket platform Trippus</a
              >
              before <b>September 19th</b>.
            </p>
            <p class="mb-0">
              If you have not registered by then we will have to give you a
              handwritten badge and while it adds a personal touch, we are not
              famous for our handwriting ;&rpar;
            </p>
            <table class="my-2">
              <tr>
                <th>Partnership</th>
                <th># of 3-day passes</th>
              </tr>
              <tr>
                <td>Top of the rock</td>
                <td>5</td>
              </tr>
              <tr>
                <td>Splash</td>
                <td>3</td>
              </tr>
              <tr>
                <td>Intro</td>
                <td>2</td>
              </tr>
            </table>
            <p class="mb-0">
              </p>
              Top of the Rock and Splash partners have the opportunity to buy
              extra "exhibition only" passes for 400€. You can purchase the
              <a
                href="https://www.trippus.net/oredev2025/PartnerExhibitor"
                target="_blank"
                rel="noopener noreferrer"
                >exhibitor pass</a
              >
              before <b>September 19th</b>. Again, if we don't have your
              registration before then, you will receive a handwritten badge.
            </p>

            <DividerBlue />

            <h2 id="preparing">Preparing for Øredev</h2>
            <h3>Set specific goals</h3>
            <p>
              The first step is to define what a successful event means to you.
              What do you want to get out of your time at Øredev? What's your
              focus?<br aria-hidden="true" />
              Set a small number of goals that you can measure; the more
              concrete they are, the better your chances are of achieving them.
              Establishing specific, measurable goals is quite likely the single
              most important thing you can do before Øredev.
            </p>
            <p class="mb-0">Examples of specific goals:</p>
            <ul>
              <li>Generating 100 sales leads</li>
              <li>Meeting 25 qualified new prospects</li>
              <li>Distributing 1000 brochures</li>
              <li>Scheduling 20 appointments</li>
            </ul>
            <p>
              We would like to remind you that we do not allow recruitment of
              new employees at Øredev. Hiring activities are forbidden on the
              exhibition floor, and mentioning any kind of recruitment
              activities connected with Øredev on your social media channels is
              prohibited.
            </p>
            <h3>Plan your booth to meet your goals</h3>
            <p>
              Your booth location, design, and activities should reflect what
              you hope to achieve. If you have a company exhibition booth in
              storage, consider how you can tailor it for Øredev.<br
                aria-hidden="true"
              />
              We advise you to build a beautiful, original booth, with things to
              experience or play with. The more interactive your booth is, the
              more visitors you will have.
            </p>
            <p>
              Prepare and bring everything that you'll need to assemble your
              booth; your booth is your responsibility!
            </p>
            <p class="mb-0">Please note:</p>
            <ul>
              <li>
                You can build back walls, but not side walls. This will obscure
                your neighbours' booth and give a boxed-in impression of the
                event. Every wall we build is a psychological obstacle for the
                visitor as they progress on the exhibition floor.
              </li>
              <li>We do not provide a TV or barcode scanner.</li>
              <li>
                If you are planning to have activities during Thursday evening
                when the party is happening, please include lighting in your
                booth. We dim the lights at night to create a cosier atmosphere.
              </li>
            </ul>
          </b-col>
        </b-row>
      </b-container>
      <b-container style="max-width: 980px">
        <b-row>
          <b-col>
            <table class="large-table">
              <tbody>
                <tr>
                  <th style="visibility: hidden"></th>
                  <th>Top of the Rock</th>
                  <th>Splash</th>
                  <th>Intro</th>
                </tr>
                <tr>
                  <th>Size</th>
                  <td>6x4m</td>
                  <td>5x3m</td>
                  <td>3x3m</td>
                </tr>
                <tr>
                  <th style="vertical-align: top">Equipment</th>
                  <td class="equipment">
                    <ul>
                      <li>Electricity outlet</li>
                      <li>Carpet&nbsp;(Selectable&nbsp;color)</li>
                      <li>No&nbsp;back&nbsp;wall</li>
                      <li>
                        Free selection of furniture to a value of 350€. (not
                        including screens, lights or graphics)
                      </li>
                    </ul>
                  </td>
                  <td class="equipment">
                    <ul>
                      <li>Electricity outlet</li>
                      <li>Carpet&nbsp;(Selectable&nbsp;color)</li>
                      <li>2 bar stools</li>
                      <li>2 bar tables</li>
                      <li>No back wall</li>
                    </ul>
                  </td>
                  <td class="equipment">
                    <ul>
                      <li>Electricity outlet</li>
                      <li>Carpet&nbsp;(Selectable&nbsp;color)</li>
                      <li>No back wall</li>
                      <li>
                        Free selection of furniture to a value of 170€. (not
                        including screens, lights or graphics)
                      </li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>

            <SwipeIcon />
          </b-col>
        </b-row>
      </b-container>
      <b-container>
        <b-row>
          <b-col>
            <DividerGreen />

            <h2 id="mass-service">Malmö Mäss-Service</h2>
            <p>
              Malmö Mäss-Service can offer you a multitude of technological and
              cosmetic extras to meet your particular needs. They have been on
              the market for more than twenty years and have lots of experience
              in creating valuable meetings between exhibitors and visitors.
              They are here to assist you in ordering your booth. You can see
              their full catalogue and place your order via their
              <a href="www.mass-service.se">website</a>.
            </p>
            <p class="mb-0">
              Questions? Contact:<br aria-hidden="true" />
              Jaqueline Tegstam Makolli - Project Leader for Øredev.<br
                aria-hidden="true"
              />
              <a href="mailto:jaqueline@mass-service.se"
                >jaqueline@mass-service.se</a
              ><br aria-hidden="true" />
              +46 765 25 10 82
            </p>

            <DividerOrange />

            <h2 id="during">During Øredev</h2>
            <h3>Staffing your booth</h3>
            <p>
              Choose the people to man your booth wisely, the mix of disciples
              you bring should be goal-driven. Do you need technical staff to
              explain things in detail? Top managers to meet blue-chip decision
              makers? Energetic extroverts for maximum smiling and sampling?
            </p>
            <p>
              From experience, we know Øredev delegates like to be challenged,
              and they are looking for technical experts and practitioners, not
              just sales representatives! We do not recommend “booth babes” at
              all.
            </p>
            <p>
              The breaks during Øredev are your rush hours, when everyone is on
              the exhibition floor and your booth is frequented by the most
              attendees. With no talks going on and few other program points
              available, these are the times when attendees are strolling around
              with time on their hands.<br aria-hidden="true" />
              We are expecting 1300 attendees (or more), including speakers.
            </p>
            <table>
              <tr>
                <th>
                  Wednesday<br class="d-block d-md-none" />
                  (Nov 5)
                </th>
                <th>
                  Thursday<br class="d-block d-md-none" />
                  (Nov 6)
                </th>
                <th>
                  Friday<br class="d-block d-md-none" />
                  (Nov 7)
                </th>
              </tr>
              <tr>
                <td>
                  08.00-09:00<br class="d-block d-md-none" />
                  (1 hour)
                </td>
                <td>
                  08.00-09:00<br class="d-block d-md-none" />
                  (1 hour)
                </td>
                <td>
                  08.00-09:00<br class="d-block d-md-none" />
                  (1 hour)
                </td>
              </tr>
              <tr>
                <td>
                  10.00-10.20<br class="d-block d-md-none" />
                  (20 min)
                </td>
                <td>
                  10.00-10.20<br class="d-block d-md-none" />
                  (20 min)
                </td>
                <td>
                  10.00-10.20<br class="d-block d-md-none" />
                  (20 min)
                </td>
              </tr>
              <tr>
                <td>
                  12:00-13:00<br class="d-block d-md-none" />
                  (1 hour)
                </td>
                <td>
                  12:00-13:00<br class="d-block d-md-none" />
                  (1 hour)
                </td>
                <td>
                  12:00-13:00<br class="d-block d-md-none" />
                  (1 hour)
                </td>
              </tr>
              <tr>
                <td>
                  14:35-14:55<br class="d-block d-md-none" />
                  (20 min)
                </td>
                <td>
                  14:35-14:55<br class="d-block d-md-none" />
                  (20 min)
                </td>
                <td>
                  14:35-15:00<br class="d-block d-md-none" />
                  (25 min)
                </td>
              </tr>
              <tr>
                <td>
                  16.30-16.50<br class="d-block d-md-none" />
                  (20 min)
                </td>
                <td>
                  16.30-16.50<br class="d-block d-md-none" />
                  (20 min)
                </td>
                <td></td>
              </tr>
            </table>
            </p>
            <h3>Lead scanning</h3>
            <p>
              We offer the option of Lead scanning during the event, where you
              can easily collect leads from the visitors at your booth by
              scanning a barcode with any mobile phone. You will collect the
              following info: name, surname, email address and country of origin
              of the participant in seconds. Here is an
              <a
                href="https://www.youtube.com/watch?v=-a7KXJ5CCfQ"
                target="_blank"
                rel="noopener noreferrer"
                >introductory video</a
              >
              to how it works (please note that areas of interest are not
              recorded at Øredev).
            </p>
            <p>
              Lead scanning is included in the Top of the Rock partnership. If
              you are a Splash partner, you have the opportunity to add this
              option at an additional cost. You will receive more information
              about how to set up and use this tool via email.
            </p>
            <p>
              We expect all partners to follow appropriate GDPR-rules when
              contacting your leads, during and after Øredev. For the privacy
              policy on scanning badges, see our
              <router-link to="/privacy-policy">Privacy policy</router-link>.
            </p>

            <h3>Interacting at Øredev</h3>
            <p>
              Here's some advice on how to make most of the human interactions
              on the exhibition floor. Never let an opportunity pass you by to
              mingle, network, find new business, or make a new friend!
            </p>
            <p>Our five top tips:</p>
            <ol>
              <li>Act like you're in a small town, say hello to everyone</li>
              <li>Talk to the people in your neighbouring booth</li>
              <li>
                Fully be in the now & engage in the discussion you're currently
                having
              </li>
              <li>
                Focus on getting their contact details, don't worry about giving
                them your own
              </li>
              <li>Laugh a lot, always remember to have fun!</li>
            </ol>

            <h3>Get away from the crowd</h3>
            <p>
              Look for opportunities to be part of a smaller group and engage in
              meaningful conversations. Maybe schedule a dinner with a few old
              and/or new contacts? You'll be surprised by the magic that happens
              in smaller groups.
            </p>

            <h3>It's your party!</h3>
            <p>
              Act as if you are the host of a big party, and the attendees are
              people you have invited. When it is a little quieter, maybe before
              a talk or while in line for lunch, take the initiative to break
              the ice and start a conversation. Introduce people to each other
              when you can, include as many as you can. After all, Øredev is
              your party, and these are your guests.
            </p>
            <p class="mb-0">
              Remember Øredev's one great motto: We're all here to share
              knowledge and to have fun learning from each other, creating new
              friendships and initiating new business.
            </p>

            <DividerPink />

            <h2 id="after">After Øredev</h2>
            <p>
              The visitors have all gone home. The stands are being taken down.
              Now is the time to follow through on all of the new opportunities
              you've generated, and measure your success.
            </p>
            <p>
              Don't squander the benefits they've worked so hard to achieve:
              this is your opportunity to capitalise on them and turn them into
              profits. Track the leads, follow up with all your new contacts.
            </p>
            <p>
              To get the most out of Øredev, start by reaching out to the five
              most promising people you met. Send them a brief email, reminding
              them who you are, where you met, and what you discussed. End the
              email with a few simple steps to make it extra easy for them to
              stay in touch.
            </p>
            <p>Here are some other actions you could take:</p>
            <ul>
              <li>
                Formulate five new business ideas based on your interactions
              </li>
              <li>Share five intriguing lessons learned with your team</li>
              <li>
                Publish five blog posts to answer the five most frequently asked
                questions
              </li>
            </ul>

            <h3>Measure your results</h3>
            <p>
              Remember your specific, measurable goals? Now is the time to
              measure your success against them. Did you generate those 100
              sales leads?
            </p>
            <p class="mb-0">
              Hopefully you will have exceeded your goals, and enjoyed the
              conference this year as much as we do every year!
            </p>

            <DividerBlue />

            <h2 id="reserve">Reserve a place for next year!</h2>
            <p>
              If you've met or exceeded your goals, this is the time to lock in
              a prime location at the next Øredev.<br aria-hidden="true" />
              And enjoy our early bird prices ;&rpar;
            </p>
            <p>
            </p>
              We look forward to seeing you there!<br aria-hidden="true" />
              The Ø-Team
            </p>
            </p>
            <p id="contacts" class="mb-0">Contacts</p>
            <p>
              Maisa Dabus - Conference Director <br aria-hidden="true" />
              <a href="mailto:maisa@oredev.org">maisa@oredev.org</a
              ><br aria-hidden="true" />
              +46 705 90 34 51
            </p>
            <p class="mb-0">
              Hanna Gustavsson - Conference Coordinator & Producer<br
                aria-hidden="true"
              />
              <a href="mailto:hanna@oredev.org">hanna@oredev.org </a
              ><br aria-hidden="true" />
              +46 735 24 14 26
            </p>

            <DividerGreen />
          </b-col>
        </b-row>
      </b-container>
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1743156669/2025/Margin-images/shooting_star_yellow.png"
        class="position-absolute gutter-image"
        style="width: 11%; left: 9%; top: 1%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/Shape_orange.png"
        class="position-absolute gutter-image"
        style="width: 8%; right: 9%; top: 9%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute gutter-image"
        style="width: 10%; left: 9%; top: 22%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Footer_pages/rocket_img.png"
        class="position-absolute gutter-image"
        style="width: 16%; right: 1%; top: 34%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/planet.png"
        class="position-absolute gutter-image"
        style="width: 14%; left: 4%; top: 44%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/pink_planet.png"
        class="position-absolute gutter-image"
        style="width: 12%; right: 3%; top: 66%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/shooting_star_yellow.png"
        class="position-absolute gutter-image"
        style="width: 11%; left: 8%; top: 78%"
        alt=""
        aria-hidden="true"
      />
      <b-img
        src="https://res.cloudinary.com/oredev/image/upload/v1742800150/2025/Margin-images/eye.png"
        class="position-absolute gutter-image"
        style="width: 10%; right: 9%; top: 95%"
        alt=""
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script>
import SwipeIcon from "@/components/SwipeIcon.vue";

export default {
  name: "partnerinfo",
  components: { SwipeIcon },
  data() {
    return {
      doctitle: `Partner Info - ${this.$store.state.conferencename}`,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@use "@/styles/variables.scss" as *;
h3 {
  font-family: Lexend, sans-serif;
  font-size: 16px;
  font-weight: 500;
  text-transform: none;
  margin-bottom: 0;
}
.large-table {
  width: auto;
  max-width: none;
  display: block;
  flex: 0 0 auto !important; /* Do not shrink or grow */
  padding: 0; /* Remove padding if necessary */
  @media screen and (max-width: 980px) {
    overflow-x: auto;
  }
}

table {
  font-family: Lexend, sans-serif;
  font-size: 16px;
  letter-spacing: 0.05em;
  border-collapse: separate;
  width: 100%;
  @media (max-width: 576px) {
    font-size: 14px;
  }
  th,
  td {
    border: 2px solid $dark-brown;
    padding: 15px;
    margin: 2px;
    text-align: center;
    font-weight: 500;
    line-height: 31px;
    @media (max-width: 576px) {
      padding: 5px;
    }
  }
  li {
    font-weight: 500;
    @media (max-width: 576px) {
      font-size: 14px;
    }
  }
  td.equipment {
    text-align: left;
    vertical-align: top;
  }
}

.gutter-image {
  @media (max-width: 1399px) {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/PartnerInfo.vue